<template>
    <form v-if="status.detail" @submit.prevent="submit">
        <b-form-group :label="$t('label.name')" label-cols="3"><b-form-input v-model.trim="form.name"
                :state="fieldState('name')" /></b-form-group>
        <b-form-group :label="$t('label.catalogCategory')" label-cols="3">
            <multiselect v-model="form.catalogCategory" track-by="value" label="text" :options="categoryOptions"
                :placeholder="$t('label.searchSelectCategory')" :loading="loading" :allow-empty="false"
                @search-change="search" />
            <div v-if="submitted && !$v.form.catalogCategory.required" class="invalid-feedback d-block">{{
                $t('label.categoryRequired') }}</div>
        </b-form-group>
        <b-form-group :label="$t('label.sequence')" label-cols="3"><b-form-input v-model.number="form.sequence"
                type="number" min="1" :placeholder="$t('label.optional')" /></b-form-group>
        <b-form-group :label="$t('label.description')" label-cols="3"><b-form-textarea v-model.trim="form.description"
                rows="4" :state="fieldState('description')" /></b-form-group>
        <b-form-group :label="$t('label.icon')" label-cols="3"><b-form-file v-model="form.icon" accept="image/*" />
            <b-form-text v-if="subcategoryUUID && form.iconUrl">{{ $t('label.keepCurrentIcon') }}</b-form-text>
            <b-form-text v-else>{{ $t('label.iconOptional') }}</b-form-text>
        </b-form-group>
        <hr class="my-3 mx-n3">
        <div class="d-flex justify-content-end">
            <b-button variant="danger" class="mr-2" @click="$emit('done')">{{ $t('label.cancel') }}</b-button>
            <b-button type="submit" variant="info" :disabled="!status.save"><span v-if="status.save">
                    {{ $t(subcategoryUUID ? 'label.updateX' : 'label.createX', [$t('module.catalogSubcategory')]) }}
                </span><b-spinner v-else small /></b-button>
        </div>
    </form>
    <div v-else class="text-center p-5"><b-spinner variant="info" /></div>
</template>
<script>
import { required } from 'vuelidate/lib/validators';
import { mapState } from 'vuex';
import Multiselect from 'vue-multiselect';
import { catalogSubcategoryMethods, lookupMethods } from '@/state/api';
import { CATALOG_SUBCATEGORY_MODULE } from '@/state/api/catalogSubcategory.state';
export default {
    name: 'CatalogSubcategoryForm',
    components: { Multiselect },
    props: {
        subcategoryUUID: { type: String, default: '' },
        searchCriteria: { type: Object, required: true },
    },
    data() {
        return {
            submitted: false,
            loading: false,
            timer: null,
            form: {
                uuid: '', name: '',
                catalogCategory: null,
                sequence: null,
                description: '',
                icon: null,
                iconUrl: ''
            }
        };
    },
    validations: {
        form: {
            name: { required },
            catalogCategory: { required },
            description: { required }
        }
    },
    computed: {
        ...mapState(CATALOG_SUBCATEGORY_MODULE, ['status']),
        details() {
            return this.$store.state.api.catalogSubcategory.details || {};
        },
        categoryOptions() {
            return this.$store.state.api.lookup.catalogCategoryDdl || [];
        }
    },
    async created() {
        await this.lookupCatalogCategory();
        await this.load();
    },
    beforeDestroy() {
        clearTimeout(this.timer);
    },
    methods: {
        ...catalogSubcategoryMethods,
        ...lookupMethods,
        fieldState(field) {
            return this.submitted ? !this.$v.form[field].$invalid : null;
        },
        option(uuid, record) {
            return this.categoryOptions.find((x) => x.value === uuid) || (uuid ? { value: uuid, text: record?.name || uuid } : null);
        },
        async load() {
            if (!this.subcategoryUUID) return;
            const result = await this.getCatalogSubcategory({ uuid: this.subcategoryUUID }); if (!result) return;
            this.form = {
                ...this.form,
                ...this.details,
                icon: null,
                catalogCategory: this.option(this.details.catalogCategoryUUID, this.details.catalogCategory)
            };
        },
        search(term) {
            clearTimeout(this.timer); this.timer = setTimeout(async () => {
                this.loading = true;
                await this.lookupCatalogCategory(term ? [term] : []); this.loading = false;
            }, 350);
        },
        async submit() {
            this.submitted = true; this.$v.$touch();
            if (this.$v.$invalid) return;
            const data = {
                ...this.form,
                catalogCategoryUUID: this.form.catalogCategory.value
            };
            const action = this.subcategoryUUID ? this.updateCatalogSubcategory : this.createCatalogSubcategory;
            const result = await action({ data, filter: this.searchCriteria });
            if (result?.success) {
                this.$emit('done')
            }
        },
    },
};
</script>
